var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6668 4.24967H35.5834V0.0830078H31.4167V4.24967H10.5834V0.0830078H6.41675V4.24967H4.33342C2.04175 4.24967 0.166748 6.12467 0.166748 8.41634V41.7497C0.166748 44.0413 2.04175 45.9163 4.33342 45.9163H37.6668C39.9584 45.9163 41.8334 44.0413 41.8334 41.7497V8.41634C41.8334 6.12467 39.9584 4.24967 37.6668 4.24967ZM37.6668 41.7497H4.33342V18.833H37.6668V41.7497ZM37.6668 14.6663H4.33342V8.41634H37.6668V14.6663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.269f48b5b295f2325680182b5fe37e53.svg";
export { ForwardRef as ReactComponent };